import {
  loginByUsername,
  refreshToken
} from '@/http/api/login'
import {
  getMyProfile,
  getMyProfilePermissions
} from "@/http/api/profile";
import {
  allEnumMetadata
} from "@/http/api/system";
import Vue from 'vue'
import RocketUI from '@aiwins/admin-ui'
Vue.use(RocketUI);

import router from '@/router/index'
import {
  getCode
} from '@/http/api/utility'
import {
  getToken,
  setToken,
  removeToken,
  setRefresh,
  getRefresh,
  setAuthTime,
  setExpires
} from '@/utils/authStore'
const user = {
  state: {
    user: '',
    sub: '',
    code: '',
    token: getToken(),
    refreshToken: '',
    refreshExpires: '',
    name: '',
    avatar: '',
    permissions: {},
    tenants: [],
    generateUpdateSettingsParams: '',
    enumMetadata: {}
  },

  mutations: {
    SET_CODE: (state, code) => {
      state.code = code
    },
    SET_SUB: (state, sub) => {
      state.sub = sub
    },
    SET_TOKEN: (state, token) => {
      state.token = token
    },
    SET_REFRESHTOKEN: (state, token) => {
      state.refreshToken = token
    },
    SET_REFRESHEXPIRES: (state, time) => {
      state.refreshExpires = time
    },
    SET_GENERATEUPDATESETTONGSPARAMS: (state, generateUpdateSettingsParams) => {
      state.generateUpdateSettingsParams = generateUpdateSettingsParams
    },
    SET_USER: (state, user) => {
      state.user = user
    },
    SET_NAME: (state, name) => {
      state.name = name
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions
    },
    SET_TENANTS: (state, tenants) => {
      state.tenants = tenants
    },
    SET_ENUMMETADATA: (state, enumMetadata) => {
      state.enumMetadata = enumMetadata
    },
  },

  actions: {
    // 用户名登录
    LoginByUsername({
      commit
    }, userInfo) {
      if (userInfo) {
        const username = userInfo.username.trim()
        return new Promise((resolve, reject) => {
          loginByUsername(username, userInfo.password, userInfo.__tenant).then(response => {
            const expires = {
              expires_in: response.data.expires_in,
              set_expires_in: new Date().getTime() + response.data.expires_in * 1000
            }
            commit('SET_TOKEN', response.data.access_token)
            commit('SET_REFRESHTOKEN', response.data.refresh_token)
            setAuthTime()
            setToken(response.data.access_token)
            setRefresh(response.data.refresh_token)
            setExpires(expires)
            resolve()
          }).catch(error => {
            commit('SET_TOKEN', '')
            commit('SET_REFRESHTOKEN', '')
            commit('SET_REFRESHEXPIRES', '')
            commit('SET_USER', '')
            commit('SET_NAME', '')
            commit('SET_AVATAR', '')
            commit('SET_PERMISSIONS', {})
            commit('SET_GENERATEUPDATESETTONGSPARAMS', '')
            removeToken()
            router.replace({
              path: '/login'
            })
            reject(error)
          })
        })
      }
    },

    // 获取用户信息
    GetUserInfo({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        getMyProfile().then(res => {
          if (res) {
            commit('SET_USER', res.result)
            commit('SET_SUB', res.result.id);
            let name = res.result.name;
            if (!name && typeof name != "undefined" && name != 0) {
              name = '匿名'
            }
            commit('SET_NAME', name)
            commit('SET_AVATAR', res.result.photoUrl)
            if (res.result.tenantId) {
              commit('SET_GENERATEUPDATESETTONGSPARAMS', `?providerName=T&providerKey=${res.result.tenantId}`)
            } else {
              commit('SET_GENERATEUPDATESETTONGSPARAMS', `?providerName=G`)
            }
            let tenantId = localStorage['Deer-Tenant-Id'] ? localStorage['Deer-Tenant-Id'].replace(/\"/g, "") : ""
            if (tenantId && tenantId !== "null") {
              commit('SET_GENERATEUPDATESETTONGSPARAMS', `?providerName=T&providerKey=${tenantId}`)
            } else {
              commit('SET_GENERATEUPDATESETTONGSPARAMS', `?providerName=G`)
            }
          }

          allEnumMetadata().then(re => {
            if (re) {
              commit('SET_ENUMMETADATA', re.result);
            }
          });

          var getPermissions = function () {
            getMyProfilePermissions().then(result => {
              let permissionsArr = [];
              let permissions = new Object();
              if (result) {
                result.result.map(i => {
                  permissionsArr.push({
                    [i.name]: i.isGranted
                  })
                })
                permissionsArr.forEach(element => {
                  Object.keys(element).forEach((ele, i) => {
                    permissions[ele] = element[ele];
                  })
                })
              }
              commit('SET_PERMISSIONS', permissions)
              resolve(res)
            }).catch(error => {
              reject(error)
            })
          }
          if (getToken()) {
            getPermissions();
          }
        }).catch(error => {
          removeToken()
          router.replace({
            path: '/login'
          })
          reject(error)
        })
      })
    },

    // 获取手机验证码
    GetCode({
      commit
    }, phone) {
      return new Promise((resolve, reject) => {
        getCode(phone).then(response => {
          if (response.code == 10200) {
            resolve(response)
          } else {
            reject('error')
          }
        }).catch(error => {
          reject(error)
        })
      })
    },

    // 刷新token
    RefreshToken({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        refreshToken(getRefresh()).then(response => {
          if (response && !response.data) {
            reject('error')
          }
          if (response && response.data.access_token) {
            const expires = {
              expires_in: response.data.expires_in,
              set_expires_in: new Date().getTime() + response.data.expires_in * 1000
            }
            commit('SET_TOKEN', response.data.access_token)
            commit('SET_REFRESHTOKEN', response.data.refresh_token)
            commit('SET_REFRESHEXPIRES', response.data.expires_in)
            setAuthTime()
            setToken(response.data.access_token)
            setRefresh(response.data.refresh_token)
            setExpires(expires)
            resolve()
          }
        }).catch(error => {
          commit('SET_TOKEN', '')
          commit('SET_REFRESHTOKEN', '')
          commit('SET_REFRESHEXPIRES', '')
          commit('SET_USER', '')
          commit('SET_NAME', '')
          commit('SET_AVATAR', '')
          commit('SET_PERMISSIONS', {})
          commit('SET_GENERATEUPDATESETTONGSPARAMS', '')
          removeToken()
          router.replace({
            path: '/login'
          })
          reject(error)
        })
      })
    },

    // 登出
    LogOut({
      commit,
      state
    }) {
      return new Promise((resolve, reject) => {
        commit('SET_TOKEN', '')
        commit('SET_REFRESHTOKEN', '')
        commit('SET_REFRESHEXPIRES', '')
        commit('SET_USER', '')
        commit('SET_NAME', '')
        commit('SET_AVATAR', '')
        commit('SET_PERMISSIONS', {})
        commit('SET_GENERATEUPDATESETTONGSPARAMS', '')
        removeToken()
        resolve()
      })
    },

    // 动态修改权限
    ChangePermissions({
      commit,
      dispatch
    }, val) {
      return new Promise((resolve, reject) => {
        getMyProfilePermissions().then(result => {
          let permissionsArr = [];
          let permissions = new Object();
          result.result.map(i => {
            permissionsArr.push({
              [i.name]: i.isGranted
            })
          })
          permissionsArr.forEach(element => {
            Object.keys(element).forEach((ele, i) => {
              permissions[ele] = element[ele];
            })
          })
          commit('SET_PERMISSIONS', permissions)
          dispatch('GenerateRoutes', result) // 动态修改权限后 重绘侧边菜单
          resolve(result)
        }).catch(error => {
          reject(error)
        })
      })
    },
  }
}

export default user